import React from 'react';
import { VerifyEmailForgotPassword } from '../../../modules/forgotPassword/components/VerifyEmailForgotPassword/VerifyEmailForgotPassword';

export function VerifyEmailForgotPasswordPage() {
	return <VerifyEmailForgotPassword />;
}
